import { render, staticRenderFns } from "./jiemoOrderDetail.vue?vue&type=template&id=251fa5d0&scoped=true&"
import script from "./jiemoOrderDetail.vue?vue&type=script&lang=js&"
export * from "./jiemoOrderDetail.vue?vue&type=script&lang=js&"
import style0 from "./jiemoOrderDetail.vue?vue&type=style&index=0&id=251fa5d0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "251fa5d0",
  null
  
)

export default component.exports